import { STATUS } from '../enum/listing-status';
import { AdInterface, AdInterfaceWithFilter } from '../store/contexts/types/ad';
import { filterOptionsInitialState, getStatus } from './listingStatus';

export function getListingWithStatus(content: AdInterface[]): AdInterface[] {
  return content?.map(item => getAdWithFilter(item));
}

export function getAdWithFilter(item: AdInterface): AdInterfaceWithFilter {
  const itemStatus = getStatus(item);

  if (!itemStatus) return item;

  const isIncomplete = itemStatus.actions.find(item => item.incomplete === true);

  if (isIncomplete) {
    const { name, text } =
      filterOptionsInitialState.find(filter => filter.name === STATUS.incomplete) ?? {};
    return {
      ...item,
      filterName: name,
      filterText: text
    };
  }

  const indexOfFoundStatus = filterOptionsInitialState.findIndex(filterOptionsItem => {
    return JSON.stringify(filterOptionsItem.statusIds) === JSON.stringify(itemStatus.statusIds);
  });

  const { name, text } = filterOptionsInitialState[indexOfFoundStatus] || {};
  return {
    ...item,
    filterName: name,
    filterText: text
  };
}
